// All active subscriptions, flattened into the shape profileStore.collections
// (and the "Your collection" panel on the profile) expects.
function buildCollections(activeSubs = []) {
    return activeSubs.map((sub) => ({
        id:   sub.id,
        name: sub.publisher?.name  || '',
        logo: sub.publisher?.logo  || '',
    }));
}

export default buildCollections;
